import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import Logo from '../../../components/common/Logo';
import { apiCall } from '../../../services/apiUtil';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setErrorMessage('No verification token provided.');
      return;
    }

    apiCall(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => {
        setStatus('success');
        setTimeout(() => {
          navigate('/signin', {
            state: {
              signupSuccess: true,
              message: 'Email verified! You can now sign in.'
            }
          });
        }, 2000);
      })
      .catch((err) => {
        setStatus('error');
        setErrorMessage(err.message || 'Invalid or expired verification link.');
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`min-h-screen ${theme.background} flex items-center justify-center p-4`}>
      <div className={`${theme.card} rounded-2xl ${theme.shadow} p-8 w-full max-w-md text-center`}>
        <Logo size="large" />

        {status === 'verifying' && (
          <>
            <h2 className={`text-2xl font-bold mt-6 ${theme.text}`}>Verifying your email...</h2>
            <p className={`mt-2 ${theme.textSecondary}`}>Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <h2 className={`text-2xl font-bold mt-6 ${theme.text}`}>Email Verified!</h2>
            <p className={`mt-2 ${theme.textSecondary}`}>Redirecting you to sign in...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 className={`text-2xl font-bold mt-6 ${theme.text}`}>Verification Failed</h2>
            <p className={`mt-2 text-red-500`}>{errorMessage}</p>
            <button
              onClick={() => navigate('/signin')}
              className={`mt-6 inline-block px-6 py-2 rounded-lg font-semibold ${theme.gradient} text-white`}
            >
              Go to Sign In
            </button>
          </>
        )}
      </div>
    </div>
  );
}
